import { render, staticRenderFns } from "./ToolsBarComponent.vue?vue&type=template&id=65c8a3e7&scoped=true&"
import script from "./ToolsBarComponent.vue?vue&type=script&lang=ts&"
export * from "./ToolsBarComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c8a3e7",
  null
  
)

export default component.exports